import { render } from "./Properties.vue?vue&type=template&id=1fd5aa38&ts=true"
import script from "./Properties.vue?vue&type=script&lang=ts"
export * from "./Properties.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__